import Form from "../../componets/Form";

export default function Section6() {
  return (
    <Form />
  );
}
